import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=01e1208e"
import script from "./ContentButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentButton.vue?vue&type=style&index=0&id=01e1208e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports